export default "__VITE_ASSET__DI6VQE2n__"